import { atom, useRecoilValue, useSetRecoilState } from 'recoil';

import localStorageEffect from '@/core/stateManager/localStorageEffect';
import whenInBrowser from '@/core/environment/whenInBrowser';

export type MonetizationOverride = 'none' | 'premium' | 'free';

/* QA aid only, not a security boundary: it overrides client-side UI gates,
 * never server-enforced entitlements. The stored value is only honored while
 * a secret-menu session token exists (sessionStorage, set after the secret
 * menu password is verified), so a stale localStorage value cannot affect the
 * app outside an authenticated secret-menu session. */
export const monetizationOverrideState = atom<MonetizationOverride>({
  key: 'user:monetizationOverride',
  default: 'none',
  effects_UNSTABLE: [
    whenInBrowser(localStorageEffect('user:monetizationOverride')),
  ],
});

export const useMonetizationOverride = () =>
  useRecoilValue(monetizationOverrideState);

export const useSetMonetizationOverride = () =>
  useSetRecoilState(monetizationOverrideState);
